import React from 'react';
import {ProductCompareUnion, ProductCompareWrapper} from "../interfaces";
import GridProduct from "../../product/grid-product";
import CloseIcon from "../../../../ui/svg/common/close";
import {rootActions, useAppDispatch, useAppSelector} from "../DAL/store";
import {cloneDeep} from "lodash";
import {removeDocFromCompareServers} from "../../../compare-servers/domain/compare-servers-provider";

const tdStyle= {
    width: '20%',
    verticalAlign: 'top',
    height: 'inherit,'
};

const removeIconStyle = {
    right: '13px',
    top: '5px',
};

interface IServer {
    productCompareUnion: ProductCompareUnion;
}

const Server = (props: IServer) => {

    const productCompareUnion  = props.productCompareUnion;
    //console.log('productCompareUnion: ',productCompareUnion);
    const dispatch = useAppDispatch();

    const pcWrap = useAppSelector(store => store.pcWrap);
    const documentIDs = useAppSelector(store => store.documentIDs);
    const removeBundle = () => {
        if(pcWrap === null)
            return;
        const copy: ProductCompareWrapper = cloneDeep(pcWrap);

        const bundleIndex = pcWrap.productCompareUnionList.findIndex(b => b.documentID === productCompareUnion.documentID);
        if(bundleIndex === -1) return;

        copy.productCompareUnionList.splice(bundleIndex, 1);

        const documentIDsCopy = [...documentIDs];
        const idIndex = documentIDsCopy.findIndex(id => id === productCompareUnion.documentID);
        if(idIndex !== -1) {
            documentIDsCopy.splice(idIndex, 1);
        }

        dispatch(
            rootActions.main({
                pcWrap: copy,
                documentIDs: documentIDsCopy,
            })
        );

        let url = window.location.pathname;
        if(documentIDsCopy.length > 0){
            url += `?ids=${ documentIDsCopy.join('-') }`;
        }

        window.history.replaceState({}, '', url);

        removeDocFromCompareServers(productCompareUnion.documentID);
    }
/*
    const removeBundle = () => {

        const copy: ICompareBundlesData = JSON.parse(JSON.stringify(data));

        const bundleIndex = copy.bundles.findIndex(b => b.skuid === bundle.skuid);
        if(bundleIndex === -1) return;

        copy.bundles.splice(bundleIndex, 1);

        const documentIDsCopy = [...documentIDs];
        const idIndex = documentIDsCopy.findIndex(id => id === bundle.documentID);
        if(idIndex !== -1) {
            documentIDsCopy.splice(idIndex, 1);
        }

        dispatch(
            rootActions.main({
                data: formatData(copy),
                documentIDs: documentIDsCopy,
            })
        );

        let url = window.location.pathname;
        if(documentIDsCopy.length > 0){
            url += `?ids=${ documentIDsCopy.join('-') }`;
        }

        window.history.replaceState({}, '', url);

        removeDocFromCompareBundles(bundle.documentID);
    };
*/
    return (
        <td
            style={ tdStyle }
            className="px-2 pb-4 border-l relative">

            <GridProduct
                product={ productCompareUnion.productListItem }
                classes="h-full"
                isPriceClockHidden={ true }
                disableImageLazy={true}
            />

            <button
                type="button"
                onClick={ removeBundle }
                className="absolute"
                style={ removeIconStyle }>
                <CloseIcon
                    width="15px"
                    color="#828282"
                    title="Remove"
                />
            </button>
        </td>
    )
};

export default Server;